module.exports = __webpack_public_path__ + "img/icon-pdf.58eb4d66.svg";